import { httpsUrlOrThrow } from './externalUrl'

/**
 * A blank tab opened on the click itself, for a page whose address the API has yet to send. A tab opened after an
 * await no longer counts as the person's own action and is blocked as a pop-up, so the tab comes first and the
 * address follows. Null when the browser blocked it anyway. It never gets a handle back on this page.
 */
export function openTabOnClick(): Window | null {
    const tab = window.open('about:blank', '_blank')
    if (tab) tab.opener = null
    return tab
}

/** Sends the tab to an https address, or closes it and says false: a `javascript:` URL would run in this page's origin. */
export function sendTabTo(tab: Window, url: string): boolean {
    try {
        tab.location.href = httpsUrlOrThrow(url)
        return true
    } catch {
        tab.close()
        return false
    }
}
